import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero2025.css";

const Hero2025: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToMap = () => {
    navigate("/2025");
  };

  return (
    <div className="landing-page">
      <section
        className="hero-section"
        style={{
          backgroundImage: "url('/images/hero-background2.jpg')",
        }}
      >
        <div className="hero-container">
          <h5>pixel.io.vn</h5>
          <h1>2025</h1>
          <p>Năm đầu tiên đã bắt đầu!</p>
          <button className="hero-button" onClick={handleNavigateToMap}>
            Tham gia ngay
          </button>
        </div>
      </section>
    </div>
  );
};

export default Hero2025;
